import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';

const Layout: React.FC = () => {
  // Renders the main application layout
  // Combines the Header, Sidebar, and main content area (via Outlet) in a flex layout
  return (
    <div className='h-screen flex flex-col'>
      <Header />
      <div className='flex flex-1 overflow-hidden'>
        <Sidebar />
        <main className='p-4 flex-1 overflow-auto bg-gray-50'>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
